import { useCallback, useState } from 'react';
import { type Mesh } from 'three';
import { useShallow } from 'zustand/shallow';

import { SnapPointPreview } from 'app/modules/wallforming/components/scenes/objects/helpers/SnapPointPreview';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

const noRaycast = () => {};

export const SnapPointMarker = () => {
    const count = usePlacementStore(useShallow((state) => state.additionalSnapPointFeedback.length));
    const [capacity, setCapacity] = useState<number>(count);

    if (count > capacity) {
        setCapacity(count);
    }

    const handleMarkerRef = useCallback((marker: Mesh | null) => {
        if (marker) {
            marker.visible = false;
        }
        usePlacementStore.getState().setSnapPointMarkerRef(marker);
    }, []);

    return (
        <>
            <mesh ref={handleMarkerRef} name="snap-point-target" raycast={noRaycast} />
            <SnapPointPreview />
            {Array.from({ length: capacity }, (_, index) => (
                <SnapPointPreview key={index} index={index} />
            ))}
        </>
    );
};
